export default __webpack_public_path__ + "static/media/express.3866df03.png";